import type { Configuration } from '../../../../../types/Configuration';
import type { ECommerceEventData, EcommerceItemWithDetails } from '../../../../../types/analytics/ECommerce';
import type { Experience } from '../../../../../types/CoreShoppingExperience';
import type { ShoppingCart } from '../../../../../types/shoppingCart/ShoppingCart';
import convertToECommerceEvent from './convertToECommerceEvent';
import convertToProductDetails from './convertToProductDetails';
import convertCartItemToItem from './convertCartItemToItem';

const convertToViewCartEvent = (
  requestId: string,
  cart: ShoppingCart,
  experience: Experience,
  partnerConfig: Configuration,
): ECommerceEventData => {
  const products = experience.purchasableTrips.flatMap((x) => x.steps).flatMap((x) => x.products);

  const items: EcommerceItemWithDetails[] = cart.items.map((cartItem) => {
    const product = products.find((product) => product.encryptedId === cartItem.encryptedProductId);
    const item = convertCartItemToItem(cartItem);

    if (product === undefined) {
      throw new Error('Failed to find the related product.');
    }

    return {
      ...item,
      ...convertToProductDetails(product.productDetails),
    };
  });

  return convertToECommerceEvent(requestId, items, partnerConfig);
};

export default convertToViewCartEvent;
